import { render, staticRenderFns } from "./QuestionnaireSettingsTab.vue?vue&type=template&id=02f6eb36&scoped=true"
import script from "./QuestionnaireSettingsTab.vue?vue&type=script&lang=js"
export * from "./QuestionnaireSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireSettingsTab.vue?vue&type=style&index=0&id=02f6eb36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f6eb36",
  null
  
)

export default component.exports